import { useEffect, useState } from "react";
import cx from "classnames";

import BreakingNewsBar from "components/BreakingNewsBar";
import HomepageNav from "./HomepageNav";
import IEDeprecationBanner from "components/IEDeprecationBanner";
import lazy from "utils/lazy";
import { HomepageQuery } from "types/api";
import styles from "./HomepageLayout.module.scss";
import HomepageTop from "./HomepageTop";
import HomepageMiddle from "./HomepageMiddle";
import CineflexAd from "components/ads/Cineflex";
import InjectorAd from "components/ads/Injector";
import adStyles from "components/ads/Injector.module.scss";
import NonMeteredNudge from "components/NonMeteredNudge";

const HomepageBottom = lazy(() => import("components/homepage/HomepageBottom"));

const Footer = lazy(() => import("components/Footer"));

const HomepageLayout = ({
  analyticsCategory,
  breakingNews,
}: {
  analyticsCategory?: string;
  breakingNews: HomepageQuery["breakingNews"];
}) => {
  const [isThickNav, setIsThickNav] = useState(true);
  const [showNudge, setShowNudge] = useState(false);

  useEffect(() => {
    if (!isThickNav) {
      setShowNudge(true);
    }
  }, [isThickNav]);

  return (
    <>
      <CineflexAd />
      <HomepageNav isThick={isThickNav} setIsThick={setIsThickNav} />
      <IEDeprecationBanner className={styles.ieDeprecationBanner} />
      {breakingNews?.homepageEnabled && (
        <BreakingNewsBar analyticsCategory={analyticsCategory} />
      )}
      <div className={styles.root}>
        <main id="main-content" data-category="homepage">
          <div className={styles.container}>
            <HomepageTop />
            <HomepageMiddle />
          </div>
          <InjectorAd
            targetingPos="hpboxpremium2"
            className={adStyles.shaded}
          />
          <div className={cx(styles.container, styles.bottom)}>
            <HomepageBottom />
          </div>
        </main>
      </div>
      {showNudge && <NonMeteredNudge />}
      <Footer analyticsCategory={analyticsCategory} />
    </>
  );
};

export default HomepageLayout;
